import * as React from 'react';
import DeliverableStatusDisplay from '../deliverable_status_display/DeliverableStatusDisplay';

// Projects and deliverables share the same status enum. A project's status is
// derived from the rollup of its deliverables (see DeliverableUtils). This is a
// thin wrapper so project-side call sites read clearly.
const ProjectStatusDisplay = ({
	status,
	showIcon = true,
	style = {},
	textStyle = {},
	...props
}) => {
	if (!status) {
		return null;
	}
	return (
		<DeliverableStatusDisplay
			status={status}
			showIcon={showIcon}
			style={style}
			textStyle={textStyle}
			{...props}
		/>
	);
};

export default ProjectStatusDisplay;
